import { createContext } from 'react';

export const CompetitionContext = createContext({
  competitions: [],
  competition: {},
  competitionRegisters: [],
  competitionRegister: {},
  competitionProvinceRanks: [],
  competitionProvinceRank: {},
  ages: [],
  sports: [],
  levels: [],
  weights: [],
  gyms: [],
  gym: {},
  provinces: [],
  types: [],
  users: [],
  user: {},
  teams: [],
  team: {},
  leagues: [],
  league: {},
  userIds: [],
  coaches: [],
  supervisors: [],
  agents: [],
  agentsList: [],
  IDCards: [],
});
